module.exports = __webpack_public_path__ + "static/media/lds-logo_fj.8d98f905.svg";